export default {
    data() {
        return {
            dragging: false,
            draggingItem: null,
            mouseX: 0,
            mouseY: 0,
            startX: 0,
            startY: 0,
            animationFrame: null,
            lastClickTime: 0,
            clickTimeout: null,
            doubleClickDelay: 250,
            dragMoved: false
        };
    },
    mounted() {
        window.addEventListener('mousemove', this.handleGlobalMouseMove);
        window.addEventListener('mouseup', this.handleGlobalMouseUp);
    },
    beforeDestroy() {
        window.removeEventListener('mousemove', this.handleGlobalMouseMove);
        window.removeEventListener('mouseup', this.handleGlobalMouseUp);
    },
    methods: {
        startDrag(item, mouse) {
            mouse.preventDefault();
            document.body.style.userSelect = 'none';
            this.startX = mouse.x;
            this.startY = mouse.y;
            this.mouseX = mouse.x;
            this.mouseY = mouse.y;
            this.draggingItem = item;
            this.dragging = true;
            this.dragMoved = false;
            document.documentElement.style.setProperty('--drag-opacity', '0');
            document.documentElement.style.setProperty('--drag-x', `${mouse.x - 15}px`);
            document.documentElement.style.setProperty('--drag-y', `${mouse.y - 10}px`);
        },
        handleGlobalMouseMove(e) {
            if (!this.dragging) return;

            if (!this.dragMoved) {
                const deltaX = Math.abs(e.clientX - this.startX);
                const deltaY = Math.abs(e.clientY - this.startY);
                if (deltaX < 5 && deltaY < 5) return;
            }

            if (this.animationFrame) cancelAnimationFrame(this.animationFrame);

            this.animationFrame = requestAnimationFrame(() => {
                const x = e.clientX - 15;
                const y = e.clientY - 10;

                this.mouseX = x;
                this.mouseY = y;
                this.dragMoved = true;

                document.documentElement.style.setProperty('--drag-opacity', '0.7');
                document.documentElement.style.setProperty('--drag-x', `${x}px`);
                document.documentElement.style.setProperty('--drag-y', `${y}px`);
            });
        },
        handleGlobalMouseUp(e) {
            if (!this.dragging) return;
            this.endDrag(this.draggingItem, { x: e.clientX, y: e.clientY });
        },
        endDrag(item, mouse) {
            if (!this.dragging) return;

            const deltaX = Math.abs(mouse.x - this.startX);
            const deltaY = Math.abs(mouse.y - this.startY);
            const wasClick = deltaX < 5 && deltaY < 5;
            if (wasClick) {
                const now = Date.now();
                const diff = now - this.lastClickTime;
                if (diff < this.doubleClickDelay) {
                    clearTimeout(this.clickTimeout);
                    this.lastClickTime = 0;
                    this.handleDoubleClickDragging(item);
                } else {
                    this.lastClickTime = now;
                    this.clickTimeout = setTimeout(() => {
                        this.handleClickDragging(item);
                    }, this.doubleClickDelay);
                }
            }
            this.resetDrag()
        },
        resetDrag() {
            this.dragging = false;
            this.draggingItem = null;
            this.dragMoved = false;

            document.body.style.userSelect = '';
            document.documentElement.style.removeProperty('--drag-x');
            document.documentElement.style.removeProperty('--drag-y');
            document.documentElement.style.setProperty('--drag-opacity', '0');

            if (this.animationFrame) {
                cancelAnimationFrame(this.animationFrame);
                this.animationFrame = null;
            }
        }
    }
};
